import { Moment } from "moment"
import { Client } from "../entity/shared/Client"
import { ContractTariff } from "../entity/shared/ContractTariff"
import { SimEssentials } from "../SimEssentials"

export interface FlexiTariffData {
  tariff: ContractTariff,
  sims: SimEssentials[],
  allowance: number,
  usage: number,
  efficiency: number,
  originalCost: number
}

export interface FlexiTariffDataOriginal {
  totalEfficiency: number,
  calculations: FlexiTariffData[],
  sims?:SimEssentials[]
}

export interface FlexiTariffCalculations {
  favouredTariff: FlexiTariffCalculation | null,
  originalTariffData: FlexiTariffDataOriginal,
  allCalculations: FlexiTariffCalculation[],
  log: any[]
}

export interface FlexiTariffResult {
	client: string,
	calcs: FlexiTariffCalculations
}

export interface FlexiTariffCalculation {
	tariffGroupInfo: ContractTariff[],
	sims: SimEssentials[],
	dtCalcsEstimated: any,
	flexiCost?: number
}

export interface ClientDataSnapshot {
	time: Moment
	client: Client
	sims: SimEssentials[]
	contractTariffs: ContractTariff[]
}

export interface FlexiTariffDataSnapshot {
	clients: ClientDataSnapshot[]
}

export interface FlexiTariffDataCaptureDescriptor {
	date: number,
	filename: string
}